export const organizationDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Pricing Type",
      accessor: "type",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
        Header: "GST Number",
        accessor: "gstNo",
     },
     {
        Header: "PAN Number",
        accessor: "panNo",
     },
     {
      Header: "Contact Number",
      accessor: "phone",
   },
    {
      Header: "Action",
      accessor: "action",
    },
  ];

  export const pricingDataColumns = [
    {
      Header: "No",
      accessor: "no",
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "User Limit",
      accessor: "userLimit",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    
    {
      Header: "Action",
      accessor: "action",
    },
  ];